// This file was automatically generated from print.visitNote.vitals.html.
// Please don't edit this file by hand.

goog.provide('el8.template.print.visitNote.vitals');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.ptdata.vitalsCollections');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.visitNote.vitals.vitalVal = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.val) ? '<span>' + soy.$$escapeHtml(opt_data.val) + '</span>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.visitNote.vitals.vitalNote = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.extraNote) {
    output.append('<span class="preserve leftIndent">(');
    if (opt_data.extraNote) {
      el8.template.print.visitNote.vitals.vitalVal(soy.$$augmentData(opt_data, {val: opt_data.extraNote}), output);
    }
    output.append(')</span>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.visitNote.vitals.bpVal = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  el8.template.print.visitNote.vitals.vitalVal(soy.$$augmentData(opt_data, {val: opt_data.bpS}), output);
  output.append('<span>/</span>');
  el8.template.print.visitNote.vitals.vitalVal(soy.$$augmentData(opt_data, {val: opt_data.bpD}), output);
  el8.template.print.visitNote.vitals.vitalNote(opt_data, output);
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.visitNote.vitals.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.hasVitals) {
    output.append('<h4>Vitals:</h4><table class="vitals"><tr><td class="vitalsText">');
    if (opt_data.displayBps.length) {
      output.append('<span class="vitalsIndent">BP:');
      var bList18293 = opt_data.displayBps;
      var bListLen18293 = bList18293.length;
      for (var bIndex18293 = 0; bIndex18293 < bListLen18293; bIndex18293++) {
        var bData18293 = bList18293[bIndex18293];
        output.append('<span class="leftIndent">');
        el8.template.print.visitNote.vitals.bpVal(bData18293, output);
        output.append((! (bIndex18293 == bListLen18293 - 1)) ? ',' : '', '</span>');
      }
      output.append('</span>');
    }
    if (opt_data.displayHrs.length) {
      output.append('<span class="vitalsIndent">HR:');
      var hList18305 = opt_data.displayHrs;
      var hListLen18305 = hList18305.length;
      for (var hIndex18305 = 0; hIndex18305 < hListLen18305; hIndex18305++) {
        var hData18305 = hList18305[hIndex18305];
        output.append('<span class="leftIndent">');
        el8.template.print.visitNote.vitals.vitalVal({val: hData18305.hr}, output);
        el8.template.print.visitNote.vitals.vitalNote(hData18305, output);
        output.append((! (hIndex18305 == hListLen18305 - 1)) ? ',' : '', '</span>');
      }
      output.append('</span>');
    }
    if (opt_data.displayTemperatures.length) {
      output.append('<span class="vitalsIndent">Temp:');
      var tList18319 = opt_data.displayTemperatures;
      var tListLen18319 = tList18319.length;
      for (var tIndex18319 = 0; tIndex18319 < tListLen18319; tIndex18319++) {
        var tData18319 = tList18319[tIndex18319];
        output.append('<span class="leftIndent">', (tData18319.temperature) ? '<span>' + soy.$$escapeHtml(tData18319.temperature) + ' °F</span>' : '');
        el8.template.print.visitNote.vitals.vitalNote(tData18319, output);
        output.append((! (tIndex18319 == tListLen18319 - 1)) ? ',' : '', '</span>');
      }
      output.append('</span>');
    }
    if (opt_data.displayRrs.length) {
      output.append('<span class="vitalsIndent">RR:');
      var rList18336 = opt_data.displayRrs;
      var rListLen18336 = rList18336.length;
      for (var rIndex18336 = 0; rIndex18336 < rListLen18336; rIndex18336++) {
        var rData18336 = rList18336[rIndex18336];
        output.append('<span class="leftIndent">');
        el8.template.print.visitNote.vitals.vitalVal(soy.$$augmentData(rData18336, {val: rData18336.rr}), output);
        el8.template.print.visitNote.vitals.vitalNote(rData18336, output);
        output.append((! (rIndex18336 == rListLen18336 - 1)) ? ',' : '', '</span>');
      }
      output.append('</span>');
    }
    if (opt_data.displayHeights.length) {
      output.append('<span class="vitalsIndent">Ht:');
      var hList18350 = opt_data.displayHeights;
      var hListLen18350 = hList18350.length;
      for (var hIndex18350 = 0; hIndex18350 < hListLen18350; hIndex18350++) {
        var hData18350 = hList18350[hIndex18350];
        output.append('<span class="leftIndent">', (hData18350.height) ? '<span>' + soy.$$escapeHtml(hData18350.height) + ' in.</span>' : '');
        el8.template.print.visitNote.vitals.vitalNote(hData18350, output);
        output.append((! (hIndex18350 == hListLen18350 - 1)) ? ',' : '', '</span>');
      }
      output.append('</span>');
    }
    if (opt_data.displayWeights.length) {
      output.append('<span class="vitalsIndent">Wt:');
      var wList18367 = opt_data.displayWeights;
      var wListLen18367 = wList18367.length;
      for (var wIndex18367 = 0; wIndex18367 < wListLen18367; wIndex18367++) {
        var wData18367 = wList18367[wIndex18367];
        output.append('<span class="leftIndent">', (wData18367.weight) ? '<span>' + soy.$$escapeHtml(wData18367.weight) + ' lbs.</span>' : '');
        el8.template.print.visitNote.vitals.vitalNote(wData18367, output);
        output.append((! (wIndex18367 == wListLen18367 - 1)) ? ',' : '', '</span>');
      }
      if (opt_data.previousWeight) {
        output.append(' ');
        el8.template.ptdata.vitalsCollections.previousVital({previousValue: opt_data.previousWeight, delta: opt_data.weightDelta, previousTime: opt_data.previousTime, units: 'lbs'}, output);
      }
      output.append('</span>');
    }
    if (opt_data.bmi) {
      output.append('<span class="vitalsIndent">BMI: ', soy.$$escapeHtml(opt_data.bmi));
      if (opt_data.previousBmi) {
        output.append(' ');
        el8.template.ptdata.vitalsCollections.previousVital({previousValue: opt_data.previousBmi, delta: opt_data.bmiDelta, previousTime: opt_data.previousTime}, output);
      }
      output.append('</span>');
    }
    if (opt_data.displayOxygens.length) {
      output.append('<span class="vitalsIndent">O<span class="subscript">2</span>:');
      var oList18404 = opt_data.displayOxygens;
      var oListLen18404 = oList18404.length;
      for (var oIndex18404 = 0; oIndex18404 < oListLen18404; oIndex18404++) {
        var oData18404 = oList18404[oIndex18404];
        output.append('<span class="leftIndent">');
        el8.template.print.visitNote.vitals.vitalVal(soy.$$augmentData(oData18404, {val: oData18404.percent}), output);
        el8.template.print.visitNote.vitals.vitalNote(oData18404, output);
        output.append((! (oIndex18404 == oListLen18404 - 1)) ? ',' : '', '</span>');
      }
      output.append('</span>');
    }
    if (opt_data.displayPains.length) {
      output.append('<span class="vitalsIndent">Pain:');
      var pList18418 = opt_data.displayPains;
      var pListLen18418 = pList18418.length;
      for (var pIndex18418 = 0; pIndex18418 < pListLen18418; pIndex18418++) {
        var pData18418 = pList18418[pIndex18418];
        output.append('<span class="leftIndent">');
        el8.template.print.visitNote.vitals.vitalVal(soy.$$augmentData(pData18418, {val: pData18418.pain}), output);
        el8.template.print.visitNote.vitals.vitalNote(pData18418, output);
        output.append((! (pIndex18418 == pListLen18418 - 1)) ? ',' : '', '</span>');
      }
      output.append('</span>');
    }
    if (opt_data.displayHcs.length) {
      output.append('<span class="vitalsIndent">HC:');
      var hcList18432 = opt_data.displayHcs;
      var hcListLen18432 = hcList18432.length;
      for (var hcIndex18432 = 0; hcIndex18432 < hcListLen18432; hcIndex18432++) {
        var hcData18432 = hcList18432[hcIndex18432];
        output.append('<span class="leftIndent">', (hcData18432.hc) ? '<span>' + soy.$$escapeHtml(hcData18432.hc) + ' cm</span>' : '');
        el8.template.print.visitNote.vitals.vitalNote(hcData18432, output);
        output.append((! (hcIndex18432 == hcListLen18432 - 1)) ? ',' : '', '</span>');
      }
      output.append('</span>');
    }
    if (opt_data.customObservations.length) {
      var vitalList18448 = opt_data.customObservations;
      var vitalListLen18448 = vitalList18448.length;
      for (var vitalIndex18448 = 0; vitalIndex18448 < vitalListLen18448; vitalIndex18448++) {
        var vitalData18448 = vitalList18448[vitalIndex18448];
        if (vitalData18448.value) {
          output.append('<span class="vitalsIndent">', soy.$$escapeHtml(vitalData18448.label), ':<span class="leftIndent"><span>', soy.$$escapeHtml(vitalData18448.value), (vitalData18448.units) ? ' ' + soy.$$escapeHtml(vitalData18448.units) : '', '</span>');
          el8.template.print.visitNote.vitals.vitalNote(vitalData18448, output);
          output.append('</span>');
          if (vitalData18448.previousValue) {
            output.append(' ');
            el8.template.ptdata.vitalsCollections.previousVital(vitalData18448, output);
          }
          output.append('</span>');
        }
      }
    }
    output.append('</td></table>');
  }
  if (!opt_sb) return output.toString();
};
